import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface ClientPriorityEditorViewProps {
    label?: string;
    value: number | null;
    onChanged: (number: number | null) => void;
    mode: ControlMode;
    required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class ClientPriorityEditorView extends React.Component<ClientPriorityEditorViewProps, any> {

    public constructor(props) {
        super(props);
    }

    public render() {
        return (
            <DropdownView label={this.props.label === undefined ? 'Priority' : this.props.label}
                onGetErrorMessage={this.props.onGetErrorMessage}
                model={this.props.value}
                required={this.props.required}
                disabled={this.props.mode == 'display'}
                onChanged={(item) => { this.props.onChanged(item != null ? item.value : null) }}
                options={
                    [
                        { value: 0, label: 'Low' },
                        { value: 1, label: 'Medium' },
                        { value: 2, label: 'Normal' },
                        { value: 3, label: 'High' },
                        { value: 4, label: 'Super' },
                        { value: 5, label: 'Vip' }
                    ]
                }
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/parts/clientpriority-editor.view.tsx